import { Button } from "../../../../../uiKit/Button/Button"
import { useState } from "react"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { DuplicateItemConfirmModal } from "../../../components/DuplicateItemConfirmModal"
import { duplicateModifierGroupModalLabel, useDuplicateModifierGroupHooks } from "./hooks"
import type { ModifierGroupFormItem } from "../../ModifierGroupForm"

type Props = {
    formItem: Maybe<ModifierGroupFormItem>
}
export const DuplicateModifierGroupBtn = ({ formItem }: Props) => {
    const [showConfirm, setShowConfirm] = useState(false)
    const { onConfirm, isLoading } = useDuplicateModifierGroupHooks(() => setShowConfirm(false))

    if (!formItem) {
        return null
    }

    return (
        <>
            <DuplicateItemConfirmModal
                isOpen={showConfirm}
                isLoading={isLoading}
                itemName={formItem.name}
                onConfirm={() => onConfirm(formItem)}
                onClose={() => setShowConfirm(false)}
                label={duplicateModifierGroupModalLabel}
            />
            <Button onClick={() => setShowConfirm(true)}>Duplicate</Button>
        </>
    )
}
